/**
 *
 * Asynchronously loads the component for DeliverySettingPage
 *
 */

import loadable from 'loadable-components';

export default loadable(() => import('./index'));
